import { render, staticRenderFns } from "./AIdj.vue?vue&type=template&id=0ee52886&scoped=true&"
import script from "./AIdj.vue?vue&type=script&lang=js&"
export * from "./AIdj.vue?vue&type=script&lang=js&"
import style0 from "./AIdj.vue?vue&type=style&index=0&id=0ee52886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee52886",
  null
  
)

export default component.exports